import React from "react";
import { QueuedUpdateContextBody } from "./types";

export const QueuedUpdateContext = React.createContext<QueuedUpdateContextBody>({
  loading: false,
  push: () => {},
  id: '',
})